module.exports = __webpack_public_path__ + "static/media/avc_brochure.8c2102d5.svg";